import { ProtectedRoute } from './ProtectedRoute';
import ProjectLayout from './ProjectLayout';

export default function ProtectedProjectLayout() {
  return (
    <ProtectedRoute>
      <ProjectLayout />
    </ProtectedRoute>
  );
}
